// Organisation und Integration Links (Runde 8, Agent 8B): Typen und Client nach crm/API.md, Abschnitt 23.2. 8B erweitert diese Datei
// nur additiv.
import { http } from "./client";

export type LinkObjekt = "lead" | "contact" | "opportunity";

export interface Organisation {
  name: string;
  /** ISO 4217 */
  waehrung: string;
  /** IANA, z. B. Europe/Berlin */
  zeitzone: string;
  wochenbeginn: "montag" | "sonntag";
  /** z. B. DE-BW */
  feiertage_region: string;
  /** JJJJ-MM-TT */
  zusaetzliche_feiertage: string[];
}

export interface IntegrationLinkVorlage {
  id: string;
  objekt: LinkObjekt;
  name: string;
  url_vorlage: string;
  aktiv: boolean;
  position: number;
}

/** Antwort von GET /api/organisation: Werte, Feiertage des Jahres und die Auswahllisten (additiv zum Vertrag) */
export interface OrganisationAntwort {
  organisation: Organisation;
  jahr: number;
  feiertage: { datum: string; name: string; quelle: "gesetzlich" | "zusaetzlich" }[];
  regionen: { code: string; name: string }[];
  zeitzonen: string[];
}

/** Platzhalter und Standardlinks, die GET /api/integration-links zusätzlich liefert (additiv zum Vertrag) */
export interface LinkKatalog {
  platzhalter: Record<LinkObjekt, { name: string; titel: string }[]>;
  standard: { objekt: LinkObjekt; name: string; url_vorlage: string }[];
}

/** Fertig aufgelöster Link für die Lead-Seite */
export interface AufgeloesterLink {
  id: string;
  name: string;
  url: string;
}

const k = encodeURIComponent;

export const organisationApi = {
  organisation: (jahr?: number) => http.get<OrganisationAntwort>("/api/organisation", { jahr }),
  organisationAendern: (e: Partial<Organisation>) => http.put<{ organisation: Organisation }>("/api/organisation", e),
  links: (objekt?: LinkObjekt) => http.get<{ data: IntegrationLinkVorlage[] } & LinkKatalog>("/api/integration-links", { objekt }),
  linkAnlegen: (e: { objekt: LinkObjekt; name: string; url_vorlage: string; aktiv?: boolean }) => http.post<{ link: IntegrationLinkVorlage }>("/api/integration-links", e),
  linksReihenfolge: (objekt: LinkObjekt, ids: string[]) => http.put<{ data: IntegrationLinkVorlage[] }>("/api/integration-links/reihenfolge", { objekt, ids }),
  /** Aufgelöste Links für die Lead-Seite (jeder angemeldete Nutzer) */
  fuer: (objekt: LinkObjekt, objektId: string) => http.get<{ data: AufgeloesterLink[] }>(`/api/integration-links/fuer/${objekt}/${k(objektId)}`),
  linkAendern: (id: string, e: { name?: string; url_vorlage?: string; aktiv?: boolean }) => http.patch<{ link: IntegrationLinkVorlage }>(`/api/integration-links/${k(id)}`, e),
  linkLoeschen: (id: string) => http.del<void>(`/api/integration-links/${k(id)}`),
};
